import { missingSpanishLines } from "./spanish-apply";
import {
  collectSpanishLines,
  normalizeTranslatableText,
  overrideForLine,
  parseSpanishOverrides,
  setOverrideForLine,
  type FormSpanishOverrides,
  type SpanishSourceForm,
} from "./spanish";

export function parseLocaleOverrides(
  value: unknown,
): Record<string, FormSpanishOverrides> {
  if (!value || typeof value !== "object" || Array.isArray(value)) return {};
  const next: Record<string, FormSpanishOverrides> = {};
  for (const [locale, overrides] of Object.entries(value)) {
    next[locale] = parseSpanishOverrides(overrides);
  }
  return next;
}

export function pruneSpanishOverrides(
  form: SpanishSourceForm,
  overrides: FormSpanishOverrides,
): FormSpanishOverrides {
  let next: FormSpanishOverrides = {};
  for (const entry of collectSpanishLines(form)) {
    const override = overrideForLine(overrides, entry.key);
    if (!override?.text.trim()) continue;
    if (
      normalizeTranslatableText(override.source) !==
      normalizeTranslatableText(entry.english)
    ) {
      continue;
    }
    next = setOverrideForLine(next, entry.key, entry.english, override.text);
  }
  return next;
}

export function spanishGapCount(
  form: SpanishSourceForm,
  overrides: FormSpanishOverrides,
  cacheByHash: Record<string, string>,
): number {
  return missingSpanishLines({ form, overrides, cacheByHash }).length;
}

export function spanishLineProgress(input: {
  form: SpanishSourceForm;
  overrides: FormSpanishOverrides;
  cacheByHash: Record<string, string>;
}): { done: number; total: number } {
  const total = collectSpanishLines(input.form).length;
  const missing = missingSpanishLines(input).length;
  return { done: Math.max(0, total - missing), total };
}
